CreditCardFormError = require '../../internal/credit-card-form-error'
CustomEvent = require 'lib/util/event/custom-event'
ldclient = require 'lib/ldclient'
Promise = require 'bluebird'
React = require 'react'
Util = require 'lib/util'
_ = require 'underscore'
f = require 'effing'
l = require 'lib/localize'
t = require 'recup'

module.exports = class extends React.Component
  gatewayFields: ['number', 'cvv', 'expirationDate']

  constructor: (props) ->
    super(props)

    fieldsEmpty = _.chain(@gatewayFields)
      .map (key) -> [key, 'empty']
      .object()
      .value()

    @state = {
      gatewayLoaded: false
      gatewayFieldStatus: fieldsEmpty
      gatewayFocusField: null
    }

  componentDidMount: ->
    @_loadGateway()
    .then =>
      @setState(gatewayLoaded: true)
      @_initialiseBraintree()

  componentWillUnmount: ->
    @_asyncDataPromise?.cancel()

  componentWillReceiveProps: (nextProps) ->
    @errorFieldChanged nextProps.errorField

  errorFieldChanged: (errorField) ->
    errorField =
      switch errorField
        when 'credit card number' then 'number'
        when 'expYear' then 'expirationDate'
        else errorField
    @setFieldStatus(errorField, 'invalid')

  _initialiseBraintree: ->
    window.braintree.client.create authorization: window.braintreeClientToken, (clientErr, clientInstance) =>
      if clientErr
        throw Error(clientErr)

      fontFamily =
        if ldclient.variation('nachos.native_system_fonts', false)
         '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans",\
         "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif'
        else
          '"Helvetica Neue", Arial, Helvetica, sans-serif'

      options =
        client: clientInstance
        styles:
          'input':
            'font-size': '16px'
            'font-family': fontFamily
        fields:
          number: { selector: '.js-card-number', placeholder: '4111 1111 1111 1111' }
          cvv: { selector: '.js-cvv', placeholder: l('cvv digits', { digits: '3' }) }
          expirationDate: { selector: '.js-expiration-date', placeholder: l('month/year abbreviation') }

      window.braintree.hostedFields.create options, (hostedFieldsErr, hostedFieldsInstance) =>
        if hostedFieldsErr
          throw Error(hostedFieldsErr)

        cvvLabel = document.querySelector('.js-cvv-label-text')

        hostedFieldsInstance.on 'cardTypeChange', (event) =>
          if (event.cards.length == 1)
            card = event.cards[0]
            @setState cardType: card.type, niceCardType: card.niceType
            cvvLabel?.textContent = card.code.name
            hostedFieldsInstance.setAttribute
              field: 'cvv'
              attribute: 'placeholder'
              value: l('cvv digits', { digits: card.code.size.toString() })
          else
            @setState cardType: null

        hostedFieldsInstance.on 'focus', (event) =>
          @setState(gatewayFocusField: event.emittedBy)

        hostedFieldsInstance.on 'blur', (event) =>
          @setState gatewayFocusField: null
          field = event.emittedBy
          fieldData = event.fields[field]
          fieldStatus =
            if fieldData.isEmpty
              'empty'
            else if fieldData.isValid
              'valid'
            else
              'invalid'
          @setFieldStatus field, fieldStatus

        hostedFieldsInstance.on 'empty', (event) =>
          @setFieldStatus event.emittedBy, 'empty'

        hostedFieldsInstance.on 'validityChange', (event) =>
          field = event.emittedBy
          fieldData = event.fields[field]
          fieldStatus =
              if fieldData.isEmpty
                'empty'
              else if fieldData.isPotentiallyValid
                'valid'
              else
                'invalid'
          @setFieldStatus field, fieldStatus

        @refs.form.addEventListener 'submit', (event) =>
          event.preventDefault()

          hostedFieldsInstance.tokenize (tokenizeErr, payload) =>
            if tokenizeErr
              @_reject(new CreditCardFormError.PostError(tokenizeErr.message))
              return
            @_resolve({ nonce: payload.nonce })


  # Create a promise that will be resolved when the braintree library calls
  # the onPaymentMethodReceived or onError handler
  _awaitData: ->
    if @_awaiting?
      @_reject(new Error("submitting form again"))

    new Promise (resolve, reject) =>
      @_awaiting = { resolve, reject }
    .finally =>
      @_awaiting = null

  _resolve: (data) ->
    @_awaiting?.resolve(data)

  _reject: (error) ->
    @_awaiting?.reject(error)

  getAsyncData: ->
    for field in @gatewayFields
      if @state.gatewayFieldStatus[field] != 'valid'
        return Promise.reject CreditCardFormError.InvalidField('', { field })

    @_asyncDataPromise?.cancel()
    @_asyncDataPromise = @_awaitData().cancellable()

    @refs.form.dispatchEvent new CustomEvent('submit', { cancelable: true })

    @_asyncDataPromise

  _loadGateway: ->
    @_loadGatewayPromise ?= Promise.try =>
      if window.braintree?
        return

      scripts = [
        'https://js.braintreegateway.com/web/3.19.0/js/client.min.js'
        'https://js.braintreegateway.com/web/3.19.0/js/hosted-fields.min.js'
      ]

      Promise.all(scripts.map (url) =>
        Util.loadScript(url))
    .return()

  setFieldStatus: (field, status) ->
    fieldStatus = _.clone @state.gatewayFieldStatus
    fieldStatus[field] = status
    @setState(gatewayFieldStatus: fieldStatus)

  render: t.renderable ->
    @props.render({
      @getAsyncData
      braintreeState: @state
      setBraintreeState: f(@, 'setState')
    })



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/internal/braintree-gateway.coffee